import { ReactComponent as EmojiStars } from '@public/icons/emoji_starsstruck.svg';
import Icon from '../atoms/Icon';

const IconEmojiStars = (props) => <Icon as={EmojiStars} {...props} />;

IconEmojiStars.propTypes = Icon.propTypes;

export default IconEmojiStars;
